// extracted by mini-css-extract-plugin
export default {"center":"Quote_center__LEqSZ","big":"Quote_big__BsAK5","bold":"Quote_bold__ADOFZ"};